import React from "react";
import { Outlet } from "react-router-dom";

import Advertise from "../../pages/LandingPage/Advertise";
import Footer from "../Footer";
// import MainHeader from '../PublicHeader';
import { BodyStyled, MainLayoutStyled, MainWrapperStyled } from "./styles";
import { ILayoutProps } from "./type";

export interface ILandingPageLayoutProps extends ILayoutProps {}

const LandingPageLayout: React.FunctionComponent<ILandingPageLayoutProps> = ({
  children,
}) => {
  return (
    <MainLayoutStyled>
      <Advertise />
      {/* <MainHeader /> */}
      <BodyStyled $isPublic>
        <MainWrapperStyled $isPublic $noPadding>
          {children || <Outlet />}
        </MainWrapperStyled>
      </BodyStyled>
      <Footer />
    </MainLayoutStyled>
  );
};

export default LandingPageLayout;
